import API from '@/api'

export default {
  namespaced: true,
  state: {
    theme: 'default',
    data: {},
    subs_status: null,
    loaded: false,
    logged: false,
    restrictions: null,
    programs: {
      used: 0,
      max: 0,
      is_available: true,
      data: null,
    }
  },
  mutations: {
    changeTheme(state, theme) {
      state.theme = theme;
    },
    getUnits(state, units) {
      state.data.units = units;
    },
    auth(state, token) {
      state.logged = true;
      localStorage.setItem('auth', token);
      env.API.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    savePrograms(state, data) {
      state.programs = data;
    },
    saveRestrictions(state, data) {
      state.restrictions = data;
    },
    saveData(state, data) {
      state.data = data;
      // Что это ??!!??!!
      if (data.units)
        window.app.$store.dispatch('unit/setTarget', data.units == 'us' ? 'US' : data.units == 'metric' ? 'Metric' : data.units);
    },
    saveSubsStatus(state, status) {
      state.subs_status = status;
    },
    load(state) {
      state.loaded = true;
    },
    logout(state, data) {
      state.data = {};
      state.logged = false;
      delete env.API.defaults.headers.common['Authorization'];
      localStorage.removeItem('auth');

      // TODO or use alot of dispatches
      document.location.reload();
    },
    setLanguage(state, lang) {
      state.data.language = lang;
    }
  },
  actions: {
    updateData({ commit, dispatch }) {
      console.log('kek');
      return API.user.getData().then(res => {
        dispatch('unit/setTarget', res.data.user.units, {root: true});

        commit('saveData', res.data.user);
        commit('saveSubsStatus', res.data.subsStatus);
        commit('saveRestrictions', res.data.restrictions)
        return res.data;
      });
    },
    availableReports({commit, state}) {
      return API.reports.load({page:1, take:9999})
        .then(res => {
            let data = {
              used: res.data.pdfs.length,
              max: 0,
              is_available: false,
              data: res.data.pdfs,
            }

            switch( state.data.subsPlan ) {
              case 'impact':
                data.max = state.data.restrictions ? state.data.restrictions.programs : 1;
              break;
              case 'exact':
                data.max = 50;
              break;
              case 'premium':
                data.max = 240;
              break;
              case 'elite':
                data.max = Infinity;
              break;
              default:
                data.max = state.data.restrictions ? state.data.restrictions.programs : 999;
              break;
            }

            if(data.max <= data.used) {
              data.is_available = false;
            } else {
              data.is_available = true;
            }
            commit('savePrograms', data);


        });
    },
  },
  getters: {
    token(state) {
      return localStorage.getItem('auth');
    },
    auth(state, getters) {
      if(getters.token) {
        return `Bearer ${getters.token}`;
      } else {
        return null;
      }
    },
    isLogged(state) {
      return state.logged;
    },
    hasPlan(state) {
      return !!state.data.subsPlan;
    },
    validSubs(state) {

      const expire = new Date(state.data.subscriptionExpire);

      return state.subs_status === 'active'
        || expire.getTime() >= Date.now();
    },
    plan(state) {
      return state.data.subsPlan;
    },
    canDoLimig(state) {
      let plan = state.data.subsPlan;
      if(plan == 'elite' || plan == 'premium') {
        return true;
      } else {
        return false;
      }
    },
    isLoaded(state) {
      return state.loaded;
    },
    data(state) {
      return state.data;
    },
    lang(state) {
      return state.data.language;
    },
    langName(state) {
      switch (state.data.language) {
        case 'en':
          return 'English';
          break;
        case 'es':
          return 'Spanish';
          break;
        case 'pt':
          return 'Portugese';
          break;
        case 'ru':
          return 'Russian';
          break;
        case 'zh':
          return 'Chinese';
          break;
        case 'jp':
          return 'Japanese';
          break;
        default:
          return 'English';
      }
    },
    subsStatus(state) {
      return state.subs_status;
    },
    availablePrograms(state) {
      return state.programs;
    },

    isSubsActive(state) {
      console.log(state.data.plan);
      return state.data.plan && [
        'active',
        'canceled',
        'trialing',
      ].includes(state.data.plan.subsStatus);
    },

    isSubsCanceled(state) {
      return !!(state.data.plan && state.data.plan.subsStatus === 'canceled');
    },

    theme(state) {
      return state.theme;
    },
    currency(state) {
      return state.data.currency;
    }
  }
};
